//$('a[href^="http"]').not('a[href^="{{ shop.url }}"]').attr('target', '_blank');

$(document).ready(() => {
  // Mobile Nav
  $('.trigger-secondary').click(function() {
    $(this)
      .next()
      .fadeIn();
    $(this)
      .closest('.nav-menu')
      .addClass('secondary-open');
  });
  $('.close-secondary').click(function() {
    $(this)
      .closest('.secondary-links')
      .fadeOut();
    $(this)
      .closest('.nav-menu')
      .removeClass('secondary-open');
  });
  $('.trigger-tertiary').click(function() {
    $(this)
      .next()
      .fadeIn();
    $(this)
      .closest('.secondary-links')
      .addClass('tertiary-open');
  });
  $('.close-tertiary').click(function() {
    $(this)
      .closest('.tertiary-links')
      .fadeOut();
    $(this)
      .closest('.secondary-links')
      .removeClass('tertiary-open');
  });

  var timesClicked = 0;
  $('#menuToggle').click(() => {
    timesClicked++;

    if (timesClicked%2==0) {
        $('.mobile-menu').removeClass('open');
        $('body').css('overflow', '');
    } else {
      $('.mobile-menu').addClass('open');
      $('body').css('overflow-y', 'hidden');
    }

  });
});

// Product page swiper
var galleryThumbs = new Swiper('.gallery-thumbs', {
  spaceBetween: 14,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true,
});

var galleryTop = new Swiper('.gallery-top', {
  autoHeight: true,
  spaceBetween: 10,
  thumbs: {
    swiper: galleryThumbs
  }
});

// Product page quantity
jQuery(document).ready(function(){
    $('.qtyplus').click(function(e){
        e.preventDefault();
        fieldName = $(this).attr('field');
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        if (!isNaN(currentVal)) {
            $('input[name='+fieldName+']').val(currentVal + 1);
        } else {
            $('input[name='+fieldName+']').val(0);
        }
    });
    $(".qtyminus").click(function(e) {
        e.preventDefault();
        fieldName = $(this).attr('field');
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        if (!isNaN(currentVal) && currentVal > 0) {
            $('input[name='+fieldName+']').val(currentVal - 1);
        } else {
            $('input[name='+fieldName+']').val(0);
        }
    });
});

// Product page accordion 
jQuery(function ($) {
  $('.accordion-tab').on('click', function () {
    $(this).next().slideToggle(200);
    $(this).toggleClass('open');
  });
});


// Blog Category swiper
var blogSwiper = new Swiper('.blog-swiper', {
  slidesPerView: 'auto',
  freeMode: true,
  pagination: {
    el: '.swiper-pagination',
	clickable: true,
  },
  breakpoints: {
    750: {
  	  slidesPerView: 'auto',
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    },
    1440: {
  	  slidesPerView: 'auto',
  	  //touchRatio: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    },
  },
});

// Testimonials swiper
  var testimonialsSwiper = new Swiper(".js-testimonials", {
        pagination: {
          el: ".swiper-pagination",
        },
      });

// Fancybox
$('[data-fancybox="gallery"]').fancybox({
  buttons: [
    "zoom",
    "close"
  ],
});